const Description = ({ text }) => {
  const base = 'text-body2Mobile md:text-body2Desktop text-olive font-chivoMono'

  return <p className={base}>{text}</p>
}

export default Description
